// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c13e2b11","450":"fa84ea86"}[chunkId] + ".chunk.js";
};